import { createContext, useContext } from 'react';

import { OfferingTransaction, TransactFlowNavigateArgs } from '@arrived/models';

export interface TransactFlowContextState {
  getTradeInProgress: () => OfferingTransaction | null;
  setTradeInProgress: (transaction: OfferingTransaction) => void;
  clearTradeInProgress: () => void;
  isTransacting: () => boolean;
  enterTransactFlow: (transaction: OfferingTransaction, navigateArgs?: TransactFlowNavigateArgs) => Promise<void>;
  navigateToNextTransactPage: (navigateArgs?: TransactFlowNavigateArgs) => Promise<void>;
}

export const TransactFlowContext = createContext({} as TransactFlowContextState);

export const useTransactFlowContext = () => {
  const context = useContext(TransactFlowContext);

  if (!context) {
    throw new Error('useTransactFlowContext must be used within a TransactFlowContextProvider');
  }

  return context;
};
